import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '../Button';

export class NextSection extends React.Component {
  goToNextSection = () => {
    this.props.toNextSection(this.props.nextSection.value);
  };

  render() {
    return (
      <Button
        className='nextSection'
        disabled={!this.props.nextSection}
        onClick={this.goToNextSection}>
        Next section
      </Button>
    );
  }
}

NextSection.propTypes = {
  nextSection: PropTypes.object,
  toNextSection: PropTypes.func,
};
